import React from 'react';
import TestPage from 'src/components/widgets/testPage/testPage';
import { useProductConfigurationState } from '../../state';

const done = () => {
	const { state } = useProductConfigurationState();

	return <TestPage productId={state.product.id!} isClassic />;
};

export default done;
